// extracted by mini-css-extract-plugin
export default {"titleArea":"titlebar_titleArea__b3VSj"};